<template>
  <v-layout text-center>
    <v-container>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title>Committees</v-toolbar-title>
            </v-toolbar>

            <v-list two-line>
              <template v-for="(committee, index) in committees">
                <v-list-tile
                  :key="committee.id"
                  avatar
                  ripple
                  @click="editCommittee(committee)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ committee.displayName }} ({{ committee.code }})</v-list-tile-title>
                    <v-list-tile-sub-title>{{ committee.displayGroup }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon
                      color="grey lighten-1"
                    >
                      mdi-pencil
                    </v-icon>

                  </v-list-tile-action>

                </v-list-tile>
                <v-divider
                  v-if="index + 1 < committees.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialog = !dialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="committee.id">Edit Committee</v-toolbar-title>
          <v-toolbar-title v-else>Add Committee</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="committee.id > 0" dark flat @click="updateCommittee">Update</v-btn>
            <v-btn v-else dark flat @click="saveCommittee">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs10>
                <v-text-field
                  v-model="committee.name"
                  label="Name"
                  @keyup.enter="saveCommittee"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  v-model="committee.code"
                  label="Code"
                  @keyup.enter="saveCommittee"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  :items="trueFalse"
                  v-model="committee.active"
                  menu-props="auto"
                  label="Active"
                  hide-details
                  @keyup.enter="saveCommittee"
                ></v-select>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  :items="trueFalse"
                  v-model="committee.view"
                  menu-props="auto"
                  label="View"
                  hide-details
                  @keyup.enter="saveCommittee"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  :items="committeeList"
                  v-model="committee.parentId"
                  item-text="name"
                  item-value="value"
                  menu-props="auto"
                  label="Parent Committee"
                  hide-details
                  @keyup.enter="saveCommittee"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  :items="execGroups"
                  v-model="committee.ExecGroupId"
                  menu-props="auto"
                  label="Liason Group"
                  hide-details
                  @keyup.enter="saveCommittee"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="committee.notes"
                  label="Notes"
                  prepend-icon="notes"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Settings',
    currentYear: 0,
    userId: 0,
    dialog: false,
    // myId: this.$store.state.user.id,
    isAdmin: false,
    committees: [],
    committeeList: [],
    committee: {},
    execGroups: [],
    trueFalse: [
      { text: 'No', value: false },
      { text: 'Yes', value: true }
    ],
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id

    this.currentYear = this.$store.state.currentYear

    this.getCommittees()
    this.getExecGroups()
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.committee = {}
      }
    }
  },

  methods: {
    async getCommittees () {
      try {
        const response = await Api().get('get_allsettingscommittees/' + this.currentYear)
        let committees = response.data
        console.log(committees)
        let committeeList = []
        let committeeItem = {}

        committeeItem.value = null
        committeeItem.name = ' None'

        committeeList.push(committeeItem)

        for (let i in committees) {
          let group = ''
          let committeeName = ''
          committeeItem = {}

          if (committees[i].ExecGroup) {
            console.log(committees[i].ExecGroup)
            group = committees[i].ExecGroup.group
          }

          // if (committees[i].parentId === null) {
          committeeName = committees[i].name
          // } else {
          // committeeName = committees[i].parent.name + '->' + committees[i].name
          // }

          committees[i].displayName = committeeName
          committees[i].displayGroup = group

          committeeItem.value = committees[i].id
          committeeItem.name = committeeName

          committeeList.push(committeeItem)
        }

        committees.sort(function (a, b) {
          let nameA = a.displayName.toLowerCase()
          let nameB = b.displayName.toLowerCase()

          if (nameA < nameB) {
            return -1
          }

          if (nameA > nameB) {
            return 1
          }

          return 0
        })

        committeeList.sort(function (a, b) {
          let nameA = a.name.toLowerCase()
          let nameB = b.name.toLowerCase()

          if (nameA < nameB) {
            return -1
          }

          if (nameA > nameB) {
            return 1
          }

          return 0
        })

        this.committees = committees
        this.committeeList = committeeList
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getExecGroups () {
      try {
        const response = await Api().get('exec_groups_list/' + this.currentYear)
        this.execGroups = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    editCommittee (committee) {
      this.committee = committee
      this.dialog = true
    },

    async saveCommittee () {
      try {
        this.committee.year = this.currentYear
        const response = await Api().post('committees', this.committee)

        this.getCommittees()

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateCommittee () {
      try {
        const response = await Api().put('committees', this.committee)

        this.getCommittees()

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/settings/Committees.vue